module.exports = __webpack_public_path__ + "img/A58A0224.cf92f646.jpg";